export const TRANSMISSION_REPORT_TYPES = [
  'Remote Transmission - Scheduled',
  'Remote Transmission - Device Alert',
  'Remote Transmission - Patient Initiated',
  'Remote Transmission - Test',
  'In-Clinic Visit - Scheduled',
  'In-Clinic Visit - Unscheduled',
  'Transmission à distance - programmée',
  'Transmission à distance - Alerte de l’appareil',
  'Transmission à distance - initiée par le patient',
  'Visite en clinique - Programmée',
  'Visite en clinique - Non programmée',
];
